import { AlertTriangleIcon } from "lucide-react"

import { Alert, AlertDescription } from "@/ui/alert"
import { Button } from "@/ui/button"

/** Loading frame for a page without a table: announces itself, pulses, respects reduced motion. */
export function PageLoading({ title, label }: { title: string; label: string }) {
  return (
    <main className="mx-auto w-full max-w-6xl space-y-6 px-6 py-8">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <div role="status" aria-label={label} aria-busy="true" className="space-y-3">
        <div className="bg-muted h-8 w-1/3 animate-pulse rounded motion-reduce:animate-none" />
        <div className="bg-muted h-48 w-full animate-pulse rounded motion-reduce:animate-none" />
      </div>
    </main>
  )
}

/** Error frame with a retry that refetches the route. */
export function PageError({
  title,
  message,
  onRetry,
}: {
  title: string
  message: string
  onRetry: () => void
}) {
  return (
    <main className="mx-auto w-full max-w-6xl space-y-6 px-6 py-8">
      <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
      <Alert variant="destructive">
        <AlertTriangleIcon aria-hidden="true" />
        <AlertDescription>
          <p>{message}</p>
          <Button variant="outline" size="sm" onClick={onRetry}>
            Try again
          </Button>
        </AlertDescription>
      </Alert>
    </main>
  )
}
